module.exports = __webpack_public_path__ + "img/courses2.a6d9ace4.jpg";